import { createSelector } from 'reselect';
import { ReduxState } from '../types';

// Base selector to get custom proxies state
const selectCustomProxiesState = (state: ReduxState) => state.customProxies;

// Selector to get all custom proxies
export const selectCustomProxies = createSelector([selectCustomProxiesState], customProxiesState => customProxiesState.customProxies || []);
